import React from 'react';
import { Field } from 'redux-form';
import Button from '@sizeid/commons/components/Button';

import Form from 'components/forms/Form';
import FormError from 'components/forms/FormError';
import FormField, { FormFieldSet } from 'components/forms/FormField';
import { isSubmitDisabled } from 'utils/forms';

import { SignInFormProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SignInForm: React.FC<any> = _props => {
  const props = _props as SignInFormProps;
  return (
    <Form id={props.id} onSubmit={props.handleSubmit}>
      <>
        <FormFieldSet>
          <Field
            name="email"
            type="email"
            placeholder={props.t('signInForm.email')}
            component={FormField}
          />
          <Field
            name="password"
            type="password"
            placeholder={props.t('signInForm.password')}
            component={FormField}
          />
        </FormFieldSet>
        {props.errorMessage && <FormError message={props.errorMessage} />}
        <Button
          type="submit"
          disabled={isSubmitDisabled(props)}
          submitting={props.submitting}
        >
          {props.t('signInForm.submit')}
        </Button>
      </>
    </Form>
  );
};

export default SignInForm;
